require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-financial-education-banzai-courses.json") })
        }
      }, "path---es-financial-education-banzai-courses");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-financial-education-banzai-courses!./.cache/json/es-financial-education-banzai-courses.json
// module id = 2488
// module chunks = 231608221292675